const STATE = {
  configuration: null,
  appMachineId: null,
}

export default STATE
